import type { AxiosInstance } from 'axios';

export interface Role {
    id: string;
    name: string;
}

export interface RolesResponse {
    data: Role[];
}

class RoleService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    index() {
        return this.apiService.get<RolesResponse>('/api/roles');
    }
}

export default RoleService;
